exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transactions-row[data-v-263edde5]{grid-template-columns:1fr 1fr .5fr .5fr .5fr}.transactions-row .span-2[data-v-263edde5]{grid-column:span 2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-263edde5","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/accounting/accounts-receivable/transactions/TransactionDetails.vue
// module id = SYLg
// module chunks = 0 1